























import { Component, Vue } from "vue-property-decorator";
import { otherUserComment } from "@/req/user";
import starRate from "@/components/starRate.vue";
@Component({ components: { starRate } })
export default class Logout extends Vue {
  public valueText = 2.5;
  public list: any = [];
  public uid: any = "";

  public mounted() {
    if (this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    }
    this.getList();
  }
  public async getList() {
    const res = await otherUserComment({ uid: this.uid });
    if (res.code == 200) {
      this.list = res.data.commentData.data;
    }
  }
}
